export default "__VITE_ASSET__D_I7LblY__"